import React from "react";
import { Share, Facebook, Twitter, MessageSquare, Hash } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface SocialShareDropdownProps {
  content: string;
}

const SocialShareDropdown: React.FC<SocialShareDropdownProps> = ({ content }) => {
  const shareToFacebook = () => {
    const text = encodeURIComponent(`Check out my RemoteViz session analysis: ${content.substring(0, 200)}...`);
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}&quote=${text}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareToX = () => {
    const text = encodeURIComponent(`Check out my RemoteViz session analysis: ${content.substring(0, 200)}... #RemoteViewing`);
    const url = `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(window.location.href)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareToReddit = () => {
    const title = encodeURIComponent('My RemoteViz Session Analysis');
    const text = encodeURIComponent(content.substring(0, 300));
    const url = `https://reddit.com/submit?title=${title}&text=${text}&url=${encodeURIComponent(window.location.href)}`;
    window.open(url, '_blank');
  };

  const shareToDiscord = () => {
    const text = encodeURIComponent(`Check out my RemoteViz session analysis: ${content.substring(0, 200)}...\n${window.location.href}`);
    // Discord doesn't have a direct share URL, so we copy to clipboard with instructions
    navigator.clipboard.writeText(`Check out my RemoteViz session analysis: ${content.substring(0, 200)}...\n${window.location.href}`);
    alert('Content copied to clipboard! You can now paste it in Discord.');
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <DropdownMenu>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <button
                type="button"
                className="w-8 h-8 rounded-full flex justify-center items-center hover:bg-accent transition-colors"
                aria-label="Share on social media"
              >
                <Share className="h-4 w-4 text-muted-foreground" />
              </button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>
            <p>Share on social media</p>
          </TooltipContent>
          <DropdownMenuContent 
            align="end" 
            className="w-56 bg-background border border-border shadow-lg z-50"
          >
            <DropdownMenuItem onClick={shareToFacebook} className="cursor-pointer">
              <Facebook className="mr-2 h-4 w-4" />
              Share on Facebook
            </DropdownMenuItem>
            <DropdownMenuItem onClick={shareToX} className="cursor-pointer">
              <Twitter className="mr-2 h-4 w-4" />
              Share on X (Twitter)
            </DropdownMenuItem>
            <DropdownMenuItem onClick={shareToReddit} className="cursor-pointer">
              <Hash className="mr-2 h-4 w-4" />
              Share on Reddit
            </DropdownMenuItem>
            <DropdownMenuItem onClick={shareToDiscord} className="cursor-pointer">
              <MessageSquare className="mr-2 h-4 w-4" />
              Share on Discord
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </Tooltip>
    </TooltipProvider>
  );
};

export default SocialShareDropdown;